import { useRouter } from "next/router";
import countries from "../constants/countries";
type Country = {
  flags: {
    png: string;
    svg: string;
    alt: string;
  };
  name: string;
  code: string;
};
const getCountryPathCode = (): Country => {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const router = useRouter();
  const countryCodePath = router.asPath.split("/")[1];
  const countryCodeISO = countryCodePath.length !== 2 ? "en" : countryCodePath;

  const countryMap: Record<string, string> = {
    "": "gb",
    en: "gb",
    cs: "cz",
    uk: "ua",
    ja: "jp",
    el: "gr",
    sr: "rs",
    sq: "al",
    kk: "kz",
    ka: "ge",
    vi: "vn",
    zh: "cn",
  };

  const countryCode = countryMap[countryCodeISO] || countryCodeISO;

  return countries.find((c) => c.code.toLowerCase() === countryCode) as Country;
};

export default getCountryPathCode;
